import type { SanityImageSource } from "@sanity/asset-utils";
import { getImageDimensions } from "@sanity/asset-utils";
import Image from "next/image";

import type { OrientedImage } from "@sorcery/cms";
import { getSanityImageUrl } from "@sorcery/utils/client/sanity";

export const SanityOrientedImage = (props: {
  value: SanityImageSource & {
    orientation?: OrientedImage["orientation"];
  };
  dataset: string;
  projectId: string;
}) => {
  const orientation = props.value?.orientation;
  const { width, height } = getImageDimensions(props.value);

  const className = orientation === "portrait" ? "sm:w-1/2 sm:float-right mb-8 sm:ml-8" : "my-8";
  return (
    <div className={className}>
      <Image
        className="mx-auto"
        src={getSanityImageUrl(props.value, props.projectId, props.dataset)
          .height(height)
          .width(width)
          .url()}
        blurDataURL={getSanityImageUrl(props.value, props.projectId, props.dataset)
          .width(24)
          .height(24)
          .blur(10)
          .url()}
        width={width}
        height={height}
        alt={(props.value as any).alt ?? ""}
        loading="lazy"
      />
    </div>
  );
};
